import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ ...params }) => {
  return await dponetAPI.get('/churn_reasons', { params })
}

const show = async ({ churnReasonId = '' }) => {
  return await dponetAPI.get(`/churn_reasons/${churnReasonId}`)
}

const create = async ({ ...data }) => {
  return await dponetAPI.post('/churn_reasons', { churnReason: data })
}

const edit = async ({ churnReasonId = '', ...data }) => {
  return await dponetAPI.put(`/churn_reasons/${churnReasonId}`, {
    churnReason: data,
  })
}

const destroy = async ({ churnReasonId = '' }) => {
  return await dponetAPI.delete(`/churn_reasons/${churnReasonId}`)
}

const churnReasons = {
  get,
  show,
  create,
  edit,
  destroy,
}

export default churnReasons
